import { withDataVersion } from '@hakimo-ui/hakimo/util';
import {
  DataVersion,
  UpsertLocationAlarmIncidentDTO,
} from '@hakimo-ui/hakimo/types';
import useAuthenticatedMutation from '../shared/useAuthenticatedMutation';

export function useResolveLocationAlarmIncident(
  onSuccess?: () => void,
  onError?: (err: Error) => void,
  dataVersion?: DataVersion
) {
  const url = `/v2/orm/location_incidents/resolve`;

  const request = new Request(url, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  withDataVersion(request, dataVersion);

  return useAuthenticatedMutation<null, UpsertLocationAlarmIncidentDTO | null>(
    request,
    {
      onSuccess,
      onSuccessInvalidationKeys: [['location_alarm_updates']],
      onError,
    }
  );
}

export default useResolveLocationAlarmIncident;
